import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { HreflangTags } from "../components/SeoHreflang";
import { Box } from "@mui/material";
import { PageWrapper } from "../components/home/HomeStyles";
import Hero from "../components/home/Hero";
import ScrollingTicker from "../components/home/ScrollingTicker";
import AboutClinic from "../components/home/AboutClinic";
import ServicesSection from "../components/home/ServicesSection";
import EmergencyBanner from "../components/home/EmergencyBanner";
import PricingPlans from "../components/home/PricingPlans";
import Testimonials from "../components/home/InstagramSection";
import ContactUs from "../components/home/ContactUs";
import InstaSection from "../components/home/InstaSection";
import FinalCTA from "../components/home/FinalCTA";

const ScrollProgress: React.FC = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const update = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(docHeight > 0 ? (scrollTop / docHeight) * 100 : 0);
    };
    window.addEventListener("scroll", update, { passive: true });
    return () => window.removeEventListener("scroll", update);
  }, []);

  return (
    <Box sx={{
      position: "fixed", top: 0, left: 0, zIndex: 9999,
      height: "3px", width: "100%", pointerEvents: "none",
    }}>
      <Box sx={{
        height: "100%", width: `${progress}%`,
        background: "linear-gradient(90deg, #1565C0, #42A5F5, #1565C0)",
        backgroundSize: "200% 100%",
        transition: "width 0.1s linear",
        boxShadow: "0 0 10px rgba(66,165,245,0.6)",
      }} />
    </Box>
  );
};

const Home: React.FC = () => (
  <PageWrapper>
    <Helmet>
      <title>Dr.Paw Veterinary Clinic — Dbayeh, Lebanon | Pet Care & Pet-Care Guides</title>
      <meta name="description" content="Dr.Paw is a compassionate veterinary clinic in Dbayeh, Lebanon — general care, dental, diagnostics, nutrition, surgery & grooming, plus vet-written pet-care guides for pet owners. Call 04 541 965." />
      <link rel="canonical" href="https://drpawleb.com/" />
      <meta property="og:url" content="https://drpawleb.com/" />
      <meta property="og:title" content="Dr.Paw Veterinary Clinic — Dbayeh, Lebanon" />
      <meta property="og:description" content="Compassionate vet care in Dbayeh, Lebanon — general care, dental, diagnostics, nutrition & grooming, plus vet-written pet-care guides for pet owners." />
    </Helmet>
    <HreflangTags />
    <ScrollProgress />
    <Hero />
    <ScrollingTicker />
    <AboutClinic />
    <ServicesSection />
    <EmergencyBanner />
    <PricingPlans />
    <Testimonials />
    <ContactUs />
    <InstaSection />
    <FinalCTA />
  </PageWrapper>
);

export default Home;
